import React, { useEffect, useRef } from 'react';
import { connect, useSelector } from 'react-redux';
import DateUtility from '../../blocks/utils/date-utility';
import NumberUtility from '../../blocks/utils/number-utility';
import { TicketListItem } from '../../models/ticket/TicketListItem';
import { ApplicationState } from '../../store';
import { getDocumentActions } from '../../store/document/actions';
import { getTicketTransactionsActions } from '../../store/ticket/actions';
import PrometTable from '../shared/promet-table/PrometTable';
import I18n from '../../blocks/localization';
import PaginationConst from '../../blocks/consts/PaginationConst';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import ContentLayout from '../core/ContentLayout';
import EuroUtility from '../../blocks/utils/euro-utility';
import CurrencyUtility from '../../blocks/utils/currency-utility/CurrencyUtility';

type Props = typeof mapDispatchToProps;

const MyTransactions = (props: Props) => {
    const pageNumber = useRef<number>(PaginationConst.FirstPage);
    const pageSize = useRef<number>(PaginationConst.DefaultPageSize);

    const transactions = useSelector((state: ApplicationState) => state.ticket.transactions);

    useEffect(() => {
        search();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const search = () => {
        props.getTransactions({ pageNumber: pageNumber.current, pageSize: pageSize.current });
    }

    const downloadPdf = (documentContentToken: string) => {
        props.getDocument(documentContentToken);
    }

    const onTablePageChange = (page: number) => {
        pageNumber.current = page;
        search();
    }

    const onTableSizeChange = (size: number) => {
        pageNumber.current = PaginationConst.FirstPage;
        pageSize.current = size;
        search();
    }

    return (
        <ContentLayout titleTranslateId='myTransactions.title'>
            {
                (transactions && !transactions.length) &&
                <>
                    {I18n.t('noTransactionsCurrently')}
                </>
            }
            {
                transactions && transactions.length > 0 &&
                <PrometTable
                    data={transactions}
                    columns={
                        [
                            { accessor: (d: TicketListItem) => DateUtility.formatWithTime(d.created), align: 'left', className: "w-200" },
                            { accessor: (d: TicketListItem) => d.name, align: 'left', className: "font-weight-500" },
                            { accessor: (d: TicketListItem) => `${d.price > 0 ? '+' : ''}${NumberUtility.format(d.price, 2, true, false, ',')} ${CurrencyUtility.getPrimaryCurrencyById(d.currencyId).sign} (${EuroUtility.convertCurrency(d.price, d.currencyId)} ${CurrencyUtility.getSecondaryCurrencyById(d.currencyId).sign})`, align: 'right', className: "font-weight-500 text-nowrap" },

                            {
                                cell: (d: TicketListItem) => (
                                    <>
                                        {
                                            d.documentContentToken &&
                                            <span onClick={() => downloadPdf(d.documentContentToken)} className="cursor-pointer">
                                                <PictureAsPdfIcon className="icon-pdf mr-2" />
                                                <span className='download-invoice-text'>{I18n.t('downloadInvoice')}</span>
                                            </span>
                                        }
                                    </>
                                ),
                                align: 'right', className: "w-200",
                                visible: transactions.filter(x => x.documentContentToken).length > 0
                            }
                        ]
                    }
                    total={transactions[0].totalCount}
                    onPageChange={(onTablePageChange)}
                    onSizeChange={onTableSizeChange}
                    page={pageNumber.current}
                    size={pageSize.current}
                    hideHeader
                />
            }
        </ContentLayout>
    );
}

const mapDispatchToProps = {
    getTransactions: getTicketTransactionsActions.request,
    getDocument: getDocumentActions.request
};

export default connect(null, mapDispatchToProps)(MyTransactions as any);
